<template lang="pug">
  .modal.active
    .modal-overlay(@click='closeModal')
    .modal-container
      .modal-header
        button.btn.btn-clear.float-right(@click='closeModal')
        .modal-title.h5 Profile
      .modal-body
        blockquote.info To change your account information, please update it on <a href="https://twitter.com/settings/account">Twitter</a> and reload this page.
        .panel-footer(v-if='checklist' @click='toggleIntakeModal')
          button.btn Edit Intake Answers
      .modal-footer
        button.btn.btn-error(@click='deleteAccount' :class='{loading: isLoading}') Delete Account
</template>





<script>
  import {mapState} from 'vuex'

  export default {
    name: 'modal-profile',

    computed: mapState([
      'checklist'
    ]),

    data () {
      return {
        isLoading: false
      }
    },

    methods: {
      closeModal () {
        this.$store.commit('toggleProfileModal')
      },

      deleteAccount () {
        this.$store.commit('deleteUser')
      },

      toggleIntakeModal () {
        this.$store.commit('toggleIntakeModal')
        if (this.isIntakeModalActive) {
          this.$router.push('/start')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/modal/Profile.vue